import { noop } from 'lodash';
export const makeMockIntercomClient = ()=>({
        boot: ()=>Promise.resolve(),
        shutdown: noop,
        showNewMessage: noop,
        update: noop,
        hideIntercom: noop,
        showIntercom: noop,
        onLoadFailed: noop,
        isLoaded: ()=>false
    });
export const makeMockIntercomClientWithJest = function makeMockIntercomClientWithJest() {
    let { isLoaded = ()=>false, hideIntercom = jest.fn(), boot = jest.fn().mockResolvedValue(undefined) } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return {
        boot,
        shutdown: jest.fn(),
        showNewMessage: jest.fn(),
        update: jest.fn(),
        hideIntercom,
        showIntercom: jest.fn(),
        onLoadFailed: jest.fn(),
        isLoaded: isLoaded
    };
};
